import ChangePassword from '../components/Authentication/ChangePassword';

const ChangePasswordPage = () => {
	return <ChangePassword />;
};

export default ChangePasswordPage;
